export const CURRENT_PUBLIC_POLICY_IDENTITY = {
  version: '2026-09-07',
  effectiveAt: '2026-09-07T00:00:00.000Z',
  termsSha256: '7f60de186b83d5e8224e379d5418902f0ed7f67ed4efad42dc90211c52d09699',
  privacySha256: '92ecf62b4a28804ea253972e0df6ea2bb35645c218a6164757e54fdfaa2992d8',
} as const;

export const CURRENT_PUBLIC_POLICY_REQUEST_IDENTITY = {
  policyVersion: CURRENT_PUBLIC_POLICY_IDENTITY.version,
  termsSha256: CURRENT_PUBLIC_POLICY_IDENTITY.termsSha256,
  privacySha256: CURRENT_PUBLIC_POLICY_IDENTITY.privacySha256,
} as const;

export const CURRENT_PUBLIC_POLICY_ACCEPTANCE = {
  policyAccepted: true as const,
  ...CURRENT_PUBLIC_POLICY_REQUEST_IDENTITY,
} as const;
